import { Typography } from '@mui/material'
import React from 'react'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import { getInstallationWithoutAccessInstallerName } from 'src/Libs/installations/utils'

interface Props {
  installation: InstallationWithoutAccess
}

/**
 * Display installer name for installations without access.
 */
const InstallationWithoutAccessInstallerName: React.FC<Props> = ({ installation }) => {
  const installerName = getInstallationWithoutAccessInstallerName(installation)
  return <Typography variant="body1">{installerName}</Typography>
}

export default InstallationWithoutAccessInstallerName
